import { reportSlardar } from '@oec-seller/sdk/utils/util';

type SlardarCommand = {
  command: string;
  args: any[];
};

const MAX_WAIT_MS = 8000;
const RETRY_INTERVAL_MS = 200;

const pendingCommands: SlardarCommand[] = [];
let firstEnqueueAt: number | null = null;
let retryIntervalId: number | null = null;

const getClient = (): any => (window as any).Slardar;

const stopRetry = (): void => {
  if (retryIntervalId !== null) {
    window.clearInterval(retryIntervalId);
    retryIntervalId = null;
  }
};

const flush = (): void => {
  const client = getClient();
  if (!client) {
    return;
  }

  stopRetry();
  firstEnqueueAt = null;

  const commands = pendingCommands.splice(0, pendingCommands.length);
  for (const { command, args } of commands) {
    try {
      client(command, ...args);
    } catch (err) {
      reportSlardar('slardar_call_failed', { error: String(err) });
    }
  }
};

const ensureRetry = (): void => {
  if (retryIntervalId !== null) {
    return;
  }

  if (firstEnqueueAt === null) {
    firstEnqueueAt = Date.now();
  }

  retryIntervalId = window.setInterval(() => {
    const client = getClient();
    if (client) {
      flush();
      return;
    }

    if (firstEnqueueAt !== null && Date.now() - firstEnqueueAt >= MAX_WAIT_MS) {
      pendingCommands.length = 0;
      firstEnqueueAt = null;
      stopRetry();
    }
  }, RETRY_INTERVAL_MS);
};

const call = (command: string, ...args: any[]): void => {
  const client = getClient();
  if (client) {
    client(command, ...args);
    return;
  }

  pendingCommands.push({ command, args });
  ensureRetry();
};

export const Slardar = {
  start: (): void => {
    call('start');
  },
  config: (params: Record<string, any>): void => {
    call('context.merge', params);
  }
};
